import { createContext, useState, useContext, useEffect, useCallback, startTransition } from 'react';
import { useLanguage } from '../Language/LanguageContext';
import { fetchData } from '../AxiosRequest/axios';

const NavbarContext = createContext();

export const NavbarProvider = ({ children }) => {
    const [navbarData, setNavbarData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { language } = useLanguage();

    const loadNavbar = useCallback(async () => {
        const cacheKey = `navbar-${language}`;
        const cacheVersionKey = `navbar-version`;
        const cached = localStorage.getItem(cacheKey);
        const cachedVersion = localStorage.getItem(cacheVersionKey);

        
        if (cached) {
            setNavbarData(JSON.parse(cached));
        } else {
            setIsLoading(true);
        }

        setError(null);
        
        try {
            const response = await fetchData({
                endpoint: 'menu',
                lang: language,
            });
        
            if (response && response.data) {
                const menuData = response.data;
                const serverVersion = String(response.cache_version);

               
                if (!cachedVersion || cachedVersion !== serverVersion) {
                    startTransition(() => {
                        setNavbarData(menuData);
                    });
                    localStorage.setItem(cacheKey, JSON.stringify(menuData));
                    localStorage.setItem(cacheVersionKey, serverVersion);
                }
            } else {
                throw new Error('Invalid menu data structure');
            }
        } catch (err) {
            console.error('Navbar fetch error:', err);


            if (cached && navbarData.length === 0) {
                startTransition(() => {
                    setNavbarData(JSON.parse(cached));
                });
            }
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    }, [language, navbarData.length]);

    useEffect(() => {
        if (!language) return;
        loadNavbar();
    }, [language, loadNavbar]);

    return (
        <NavbarContext.Provider value={{ navbarData, setNavbarData, isLoading, error }}>
            {children}
        </NavbarContext.Provider>
    );
};

export const useNavbar = () => {
    const context = useContext(NavbarContext);
    if (context === undefined) {
        throw new Error('useNavbar must be used within a NavbarProvider');
    }
    return context;
};
